<template>
  <div id="contenedor-desktop-listado-contrato-inventarios">
    <v-row
      dense>
      <!-- Listado -->
      <template
        v-for="inventario in listado">
        <template>
          <v-col
            cols="12"
            md="4"
            :key="`inventario-${inventario.id}`">
            <v-card
              elevation-1
              outline
              dense>
              <v-card-title>
                <!-- {{ new Date(`${inventario.fecha} 00:00:0`).toLocaleDateString() }} -->
                {{ $moment(inventario.fecha).format('D/MM/YYYY')}}
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  @click="editar(inventario)">
                  <v-icon>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="borrar(inventario)">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <!-- Listado de insumos -->
                <v-list
                  subheader>
                  <template
                    v-for="agrupador in inventario.insumosAgrupados">
                    <template>
                      <v-subheader
                        :key="`subtitulo-${agrupador.agrupador}`">
                        {{ agrupador.agrupador }}
                      </v-subheader>
                      <v-divider
                        :key="`divider-${agrupador.agrupador}`"
                        class="mb-1">
                      </v-divider>
                      <!-- listado de insumos -->
                      <template
                        v-for="insumo in agrupador.insumos">
                        <template>
                          <v-list-item
                            link
                            :key="insumo.idInsumo">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ insumo.insumo.descripcion }}
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-chip
                                :color="insumo.cantidad > 0 ? 'info' : ''">
                                {{ insumo.cantidad }}
                              </v-chip>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </template>
                    </template>
                  </template>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </template>
      </template>
    </v-row>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'DesktopListadoContratoInventarios',
  props: {
    listadoInventarios: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    editar(inventario) {
      eventBus.$emit('editar-inventario-contrato', inventario);
    },
    borrar(inventario) {
      eventBus.$emit('eliminar-inventario-contrato', inventario);
    },
  },
  computed: {
    listado() {
      return this.listadoInventarios.map((iventario) => ({
        id: iventario.id,
        fecha: iventario.fecha,
        insumos: iventario.insumos,
        insumosAgrupados: [
          {
            agrupador: 'Personal',
            insumos: iventario.insumos
              .filter(({ insumo }) => insumo.tipo === 1)
              .sort((a, b) => a.insumo.orden - b.insumo.orden),
          },
          {
            agrupador: 'Maquinaria',
            insumos: iventario.insumos
              .filter(({ insumo }) => insumo.tipo === 2)
              .sort((a, b) => a.insumo.orden - b.insumo.orden),
          },
          {
            agrupador: 'Equipo',
            insumos: iventario.insumos
              .filter(({ insumo }) => insumo.tipo === 3)
              .sort((a, b) => a.insumo.orden - b.insumo.orden),
          },
        ],
      }));
    },
  },
};
</script>

<style lang="scss">

</style>
